import { gql } from '@apollo/client';

export const DELETE_CHRIRP_MUTATION = gql`
  mutation DeleteChirp($id: ID!) {
    deleteDailychirp(input: { where: { id: $id } }) {
      dailychirp {
        id
      }
    }
  }
`;
